// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"7a3f78f43b20381e8a45","496":"2ae8b5c02fe154e75063","644":"9d3dbb16d551fadb1be3","721":"c15c633811576e527321","806":"cff1f3c2f621d6bbf94c"}[chunkId] + ".js";
};